export class ComboSystem {
  private comboCount: number = 0;
  private comboTimer: number = 0;
  private maxComboTime: number = 2.0;
  private comboMultiplier: number = 1;
  
  update(deltaTime: number): void {
    if (this.comboTimer > 0) {
      this.comboTimer -= deltaTime;
      if (this.comboTimer <= 0) {
        this.resetCombo();
      }
    }
  }
  
  addKill(): void {
    this.comboCount++;
    this.comboTimer = this.maxComboTime;
    this.updateMultiplier();
  }
  
  private updateMultiplier(): void {
    if (this.comboCount >= 20) {
      this.comboMultiplier = 4;
    } else if (this.comboCount >= 10) {
      this.comboMultiplier = 3;
    } else if (this.comboCount >= 5) {
      this.comboMultiplier = 2;
    } else {
      this.comboMultiplier = 1;
    }
  }
  
  getScoreMultiplier(): number {
    return this.comboMultiplier;
  }
  
  getComboCount(): number {
    return this.comboCount;
  }
  
  getComboProgress(): number {
    return this.comboTimer / this.maxComboTime;
  }
  
  private resetCombo(): void {
    this.comboCount = 0;
    this.comboMultiplier = 1;
  }
  
  clear(): void {
    this.comboCount = 0;
    this.comboTimer = 0;
    this.comboMultiplier = 1;
  }
  
  render(ctx: CanvasRenderingContext2D, x: number, y: number): void {
    if (this.comboCount < 2) return;
    
    ctx.save();
    ctx.font = 'bold 24px Arial';
    ctx.textAlign = 'left';
    
    const alpha = Math.min(1, this.comboTimer);
    ctx.globalAlpha = alpha;
    
    ctx.fillStyle = '#000';
    ctx.fillText(`COMBO x${this.comboCount}`, x + 2, y + 2);
    
    const color = this.comboMultiplier >= 4 ? '#ff00ff' : 
                  this.comboMultiplier >= 3 ? '#ff0000' : 
                  this.comboMultiplier >= 2 ? '#ffff00' : '#ffffff';
    ctx.fillStyle = color;
    ctx.fillText(`COMBO x${this.comboCount}`, x, y);
    
    ctx.font = '16px Arial';
    ctx.fillStyle = '#ffffff';
    ctx.fillText(`Score x${this.comboMultiplier}`, x, y + 25);
    
    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(x, y + 35);
    ctx.lineTo(x + 120 * this.getComboProgress(), y + 35);
    ctx.stroke();
    
    ctx.restore();
  }
}